import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    PhoneIcon,
    EnvelopeIcon,
    MapPinIcon,
    ClockIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const [showBackToTop, setShowBackToTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowBackToTop(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const quickLinks = [
        { name: "Home", to: "/" },
        { name: "About Us", to: "/about" },
        { name: "Services", to: "/services" },
     
        { name: "Gallery", to: "/gallery" },
       
        { name: "Career", to: "/career" },
        { name: "Contact", to: "/contact" }
    ];

    const services = [
        "Synthetic Turf",
        "Running Tracks",
        "Multi-Sport Courts",
        "Indoor Sports Facilities",
        "Cricket Infrastructure",
        "Football Grounds",
        "Tennis Courts",
        "Basketball Courts"
    ];

    const contactInfo = [
        {
            icon: <PhoneIcon className="w-6 h-6" />,
            title: "Phone",
            content: "+91 8400740120 / +91 9936175966",
            link: "tel:+918400740120"
        },
        {
            icon: <EnvelopeIcon className="w-6 h-6" />,
            title: "Email",
            content: "sportsexpertsinfra@gmail.com",
            link: "mailto:sportsexpertsinfra@gmail.com"
        },
        {
            icon: <MapPinIcon className="w-6 h-6" />,
            title: "Address",
            content: "Prem Nagar, Erragadda, Hyderabad - 500018, INDIA",
            link: "https://maps.google.com"
        },
        {
            icon: <ClockIcon className="w-6 h-6" />,
            title: "Business Hours",
            content: "Mon-Sat: 9:00 AM - 7:00 PM",
            link: null
        }
    ];

    const socialLinks = [
        {
            name: "Facebook",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
            ),
            link: "https://www.facebook.com/share/1CU5p1FDdr/"
        },
        {
            name: "Instagram",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
            ),
            link: "https://www.instagram.com/sportsexpertsinfra?igsh=MTJoOW05Y3lxbW9sNA=="
        },
        {
            name: "LinkedIn",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
            ),
            link: "https://linkedin.com/company/sssportinfra"
        },
        {
            name: "YouTube",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
                </svg>
            ),
            link: "https://youtube.com/@sportsexpertsinfra?si=yn_Uv7AO1B_1tDny"
        }
    ];

    return (
        <footer className="bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-gray-300 relative">
            {/* Decorative Elements */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"></div>

            {/* Newsletter Section */}
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 py-12">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex flex-col md:flex-row items-center justify-between">
                        <div className="mb-6 md:mb-0 text-center md:text-left">
                            <h3 className="text-2xl font-bold text-white mb-2">Stay Updated</h3>
                            <p className="text-indigo-100">Subscribe to our newsletter for the latest updates and offers</p>
                        </div>
                        <form className="flex flex-col sm:flex-row w-full md:w-auto gap-2">
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-300 w-full md:w-64 bg-white/10 text-white placeholder-gray-300"
                            />
                            <button
                                type="submit"
                                className="bg-white text-indigo-600 px-6 py-3 rounded-lg font-semibold hover:bg-indigo-50 transition-colors duration-300"
                            >
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-6 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 overflow-hidden">
                    {/* Company Info */}
                    <div className="space-y-4">
                        <h3 className="text-white text-xl font-bold mb-4">Sports Experts Infra</h3>
                        <p className="text-sm leading-relaxed">
                            India's leading sports infrastructure company, dedicated to creating world-class sports facilities that inspire athletes and communities.
                        </p>
                        <div className="flex space-x-4 pt-2">
                            {socialLinks.map((social, index) => (
                                <a
                                    key={index}
                                    href={social.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-gray-700 p-2 rounded-full hover:bg-indigo-600 transition-colors duration-300"
                                    title={social.name}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-white text-lg font-semibold mb-6">Quick Links</h3>
                        <ul className="space-y-3">
                            {quickLinks.map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.to}
                                        className="text-sm hover:text-white transition-colors duration-300 flex items-center group"
                                    >
                                        <ArrowRightIcon className="w-4 h-4 mr-2 text-indigo-400 group-hover:translate-x-1 transition-transform duration-300" />
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-white text-lg font-semibold mb-6">Our Services</h3>
                        <ul className="space-y-3">
                            {services.map((service, index) => (
                                <li key={index} className="text-sm flex items-center group">
                                    <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full mr-2 group-hover:scale-150 transition-transform duration-300"></span>
                                    {service}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-white text-lg font-semibold mb-6">Contact Info</h3>
                        <ul className="space-y-4">
                            {contactInfo.map((info, index) => (
                                <li key={index} className="flex items-start space-x-3 group">
                                    <div className="text-indigo-400 mt-1 group-hover:scale-110 transition-transform duration-300">
                                        {info.icon}
                                    </div>
                                    <div>
                                        <h4 className="text-sm font-medium text-white">{info.title}</h4>
                                        {info.link ? (
                                            <a
                                                href={info.link}
                                                className="text-sm hover:text-white transition-colors duration-300"
                                            >
                                                {info.content}
                                            </a>
                                        ) : (
                                            <p className="text-sm">{info.content}</p>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-700">
                <div className="max-w-7xl mx-auto px-6 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="text-sm text-center md:text-left">
                            <p>© {currentYear} Sports Experts Infra. All rights reserved.</p>
                            <p className="text-gray-400 mt-1">ISO 900 1:2015 Certified Company</p>
                        </div>
                        <div className="flex space-x-6 mt-4 md:mt-0">
                            <Link to="/privacy-policy" className="text-sm hover:text-white transition-colors duration-300">
                                Privacy Policy
                            </Link>
                            <Link to="/terms-of-service" className="text-sm hover:text-white transition-colors duration-300">
                                Terms of Service
                            </Link>
                            <Link to="/sitemap" className="text-sm hover:text-white transition-colors duration-300">
                                Sitemap
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* WhatsApp Button */}
            <a
                href="https://wa.me/919936175966"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-20 right-6 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-300 z-50"
                title="Chat with us on WhatsApp"
            >
                <ChatBubbleLeftRightIcon className="w-6 h-6" />
            </a>

            {/* Back to Top Button */}
            {showBackToTop && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-6 right-6 bg-indigo-600 text-white p-3 rounded-full shadow-lg hover:bg-indigo-700 transition-colors duration-300 z-50"
                    title="Back to top"
                >
                    <ArrowUpIcon className="w-6 h-6" />
                </button>
            )}
        </footer>
    );
};

export default Footer;
